import { render, staticRenderFns } from "./ImportBudgetDialog.vue?vue&type=template&id=6b961162&scoped=true"
import script from "./ImportBudgetDialog.vue?vue&type=script&lang=js"
export * from "./ImportBudgetDialog.vue?vue&type=script&lang=js"
import style0 from "./ImportBudgetDialog.vue?vue&type=style&index=0&id=6b961162&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b961162",
  null
  
)

export default component.exports